module.exports = __webpack_public_path__ + "static/media/branding.212cda3b.png";